<template>
  <div :class="['col-xs-12', `col-md-${size}`]">
    <form-group-search-select-multiple
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="disciplina || []"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import MatriculaService from "../../../../domain/corpore/MatriculaService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "c-protocolo-disciplina-reprovado",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: "6"
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: Array,
    required: Boolean,
    cursoId: null,
    login: {
      type: String,
      default: ""
    }
  },
  methods: {
    onChange() {
      let qtdDisciplinas = 1;

      if (this.value && this.value.length > 0) {
        qtdDisciplinas = this.value.length;

        this.value.forEach(function(dados) {
          let nomeDisciplina = dados.text.toUpperCase();
          if (
            nomeDisciplina.includes("ATIVIDADES") &&
            nomeDisciplina.includes("COMPLEMENTARES")
          ) {
            qtdDisciplinas = qtdDisciplinas - 1;
          }
        });
      }
      this.$store.state.qtdDisciplinas = qtdDisciplinas;
    }
  },
  watch: {
    value: function() {
      this.onChange();
    }
  },
  computed: {
    usuario() {
      return this.$store.state.usuario;
    }
  },
  mounted() {
    this.$el.value = this.value;
    this.$store.state.qtdDisciplinas = 0;
  },
  asyncComputed: {
    disciplina() {
      let curso = this.formValues.cursoId;
      if (curso) {
        let login = this.login != "" ? this.login : this.usuario.login;

        const matriculaService = new MatriculaService(this.$http);
        return matriculaService
          .getDisciplinasReprovadoMatricula(login, curso)
          .then(result => {
            return result.map(disciplina => ({
              value: disciplina.CODDISC,
              text: disciplina.DISCIPLINA
            }));
          })
          .catch(err => {
            SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
          });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/DisciplinaReprovado.vue